import { Statistic } from "antd";
import React, { createContext, useContext } from "react";
import { Observer } from "mobx-react-lite";

import FlowstationPerformanceStore from "../store/FlowstationPerformanceStore";

import { ProgressIndicator } from "@fluentui/react";
const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);
export const TotalOilCard = () => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );

  return (
    <div className="ms-Grid " dir="ltr">
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Observer>
            {() =>
              flowstationPerformanceStore.isLoading ? (
                <div style={{ paddingTop: "25px" }}>
                  <ProgressIndicator
                    label="Loading  total oil dashlet,please wait..."
                    description=""
                  />
                </div>
              ) : (
                <div className="ms-Grid" dir="ltr">
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                      <Statistic
                        title={
                          <div style={{ fontSize: "20px", paddingTop: "10px" }}>
                            Total Oil
                          </div>
                        }
                        value={Number(
                          flowstationPerformanceStore.totalOil
                        ).toLocaleString()}
                        suffix={
                          <span
                            style={{ fontSize: "16px", fontFamily: "consolas" }}
                          >
                            bopd
                          </span>
                        }
                        valueStyle={{
                          fontSize: "30px",
                          color: "red",
                          fontFamily: "consolas",
                        }}
                        prefix={
                          <div
                            style={{ fontSize: "12px", color: "gray" }}
                          >{`@${flowstationPerformanceStore.selMonthName},${flowstationPerformanceStore.selYear}`}</div>
                        }
                      />
                    </div>
                  </div>
                </div>
              )
            }
          </Observer>
        </div>
      </div>
    </div>
  );
};

